<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="invalidDates">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Invalid Booking Dates</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical>
          </v-divider>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="dialogAddNew=!dialogAddNew">Add</v-btn>
          <v-dialog v-model="dialogAddNew" max-width="500px">
            <v-card>
               <v-card-title>
                Add new invalid booking date
              </v-card-title>
              <v-card-text>
                <ValidationObserver ref="invalidBookingDate" v-slot="{ invalid, valid, errors }">
                  <v-form v-model="isValid">
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <validation-provider
                          name="Invalid booking date"
                          :rules="'required'"
                          v-slot="{errors}" slim>
                          <v-text-field
                            v-model="fmtNewInvalidBookingDate"
                            label="Add invalid booking date"
                            prepend-icon="mdi-calendar-plus"
                            readonly
                            :error-messages="errors"
                            v-on="on">
                          </v-text-field>
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="newInvalidBookingDate"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAddNewInvalidDate">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="addInvalidBookingDate">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title>
                Are you sure you want to delete this item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteInvalidDateConfirmed">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.bookingDate="{ item }">
          <span>{{$moment(item.bookingDate).format(SHORT_DATE_FORMAT)}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="deleteInvalidDate(item)">
          mdi-eraser
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
/* eslint-disable camelcase */
import { required } from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

extend('required', required);

export default {
  name: 'invalidDates',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    newInvalidBookingDate: null,
    isValid: false,
    menu1: false,
    invalidDates: [],
    dialogDelete: false,
    dialogAddNew: false,
    deleteItem: null,
    headers: [
      {
        text: 'Invalid Booking Date',
        align: 'start',
        sortable: false,
        value: 'bookingDate',
      },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(['INVALID_BOOKING_DATES', 'IS_ADMINISTRATOR', 'SHORT_DATE_FORMAT', 'DISPLAY_DATE_FORMAT']),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
    ]),
    fmtNewInvalidBookingDate() {
      if (!this.newInvalidBookingDate) {
        return null;
      }
      return this.$moment(this.newInvalidBookingDate).format(this.DISPLAY_DATE_FORMAT);
    },
  },
  watch: {
    dialogDelete(val) {
      return val || this.closeDelete();
    },
  },
  mounted() {
    this.retrieveInvalidBookingDates();
  },
  methods: {
    ...mapActions(['GET_INVALID_BOOKING_DATES', 'SAVE_INVALID_BOOKING_DATE', 'DELETE_INVALID_BOOKING_DATE']),
    retrieveInvalidBookingDates() {
      this.GET_INVALID_BOOKING_DATES()
        .then(() => {
          this.invalidDates = this.INVALID_BOOKING_DATES;
          this.isLoading = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    closeAddNewInvalidDate() {
      this.newInvalidBookingDate = null;
      this.dialogAddNew = false;
    },
    deleteInvalidDate(item) {
      this.deleteItem = item;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deleteItem = null;
      this.dialogDelete = false;
    },
    deleteInvalidDateConfirmed() {
      this.DELETE_INVALID_BOOKING_DATE(this.deleteItem.id)
        .then(() => {
          this.retrieveInvalidBookingDates();
          this.deleteItem = null;
          this.dialogAddNew = false;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.dialogDelete = false;
    },
    addInvalidBookingDate() {
      this.$refs.invalidBookingDate.validate().then((success) => {
        this.isValid = success;
        if (this.isValid) {
          this.SAVE_INVALID_BOOKING_DATE({ bookingDate: this.newInvalidBookingDate })
            .then(() => {
              this.retrieveInvalidBookingDates();
              this.newInvalidBookingDate = null;
              this.dialogAddNew = false;
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
  },
};
</script>
